import "./App.css";
import { register } from "swiper/element/bundle";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import ReactDOM from "react-dom/client";
import { store } from "./redux/store/store";
import HomeScreen from "./dashboard/dashscreen/HomeScreen";
import DashBoardScreen from "./AdminDashboard/dashscreen/DashBoardScreen";
import SideBarScreen from "./AdminDashboard/dashscreen/sidebar/SideBarScreen";
import AdminLogin from "./AdminDashboard/dashscreen/eraser/AdminLogin";
import AdminDashboard from "./AdminDashboard/dashscreen/eraser/AdminDashboard";
import AdminUsersPage from "./AdminDashboard/dashscreen/eraser/AdminUsersPage";
import AdminUsersCreatePage from "./AdminDashboard/dashscreen/eraser/AdminUsersCreatePage";
import AdminAdvocatesPage from "./AdminDashboard/dashscreen/eraser/AdminAdvocatesPage";
import AdminAdvocatesCreatePage from "./AdminDashboard/dashscreen/eraser/AdminAdvocatesCreatePage";
import AdminNoticesPage from "./AdminDashboard/dashscreen/eraser/AdminNoticesPage";
import AdminNoticesCreatePage from "./AdminDashboard/dashscreen/eraser/AdminNoticesCreatePage";
import AdminPaymentsPage from "./AdminDashboard/dashscreen/eraser/AdminPaymentsPage";
import AdminPaymentsCreatePage from "./AdminDashboard/dashscreen/eraser/AdminPaymentsCreatePage";
import AdminWithdrawalsPage from "./AdminDashboard/dashscreen/eraser/AdminWithdrawalsPage";
import AdminWithdrawalsCreatePage from "./AdminDashboard/dashscreen/eraser/AdminWithdrawalsCreatePage";
import AdminDocumentsPage from "./AdminDashboard/dashscreen/eraser/AdminDocumentsPage";
import AdminDocumentsCreatePage from "./AdminDashboard/dashscreen/eraser/AdminDocumentsCreatePage";
import AdminTemplatesPage from "./AdminDashboard/dashscreen/eraser/AdminTemplatesPage";
import AdminTemplatesCreatePage from "./AdminDashboard/dashscreen/eraser/AdminTemplatesCreatePage";
import AdminIntegrationsPage from "./AdminDashboard/dashscreen/eraser/AdminIntegrationsPage";
import AdminIntegrationsCreatePage from "./AdminDashboard/dashscreen/eraser/AdminIntegrationsCreatePage";
import HomeDirectoryManager from "./AdminDashboard/dashscreen/eraser/HomeDirectoryManager";

import ClientLogin from "./AdminDashboard/dashscreen/eraser/ClientLogin";
import RegisterClient from "./AdminDashboard/dashscreen/eraser/ClientRegister";
import LawyerLogin from "./AdminDashboard/dashscreen/eraser/LawyerLogin";
import LawyerRegister from "./AdminDashboard/dashscreen/eraser/LawyerRegister";
import ClientSideBarScreen from "./AdminDashboard/dashscreen/sidebar/ClientSideBarScreen";
import ClientDashboard from "./AdminDashboard/dashscreen/eraser/ClientDashboard";
import ClientNoticeSubmission from "./AdminDashboard/dashscreen/eraser/ClientNoticeSubmission";
import ClientMyNotices from "./AdminDashboard/dashscreen/eraser/ClientMyNotices";
import ClientDocuments from "./AdminDashboard/dashscreen/eraser/ClientDocuments";
import ClientPayments from "./AdminDashboard/dashscreen/eraser/ClientPayments";
import ClientDeliveryTracking from "./AdminDashboard/dashscreen/eraser/ClientDeliveryTracking";
import ClientDownloads from "./AdminDashboard/dashscreen/eraser/ClientDownloads";
import ClientProfilePage from "./AdminDashboard/dashscreen/eraser/ClientProfilePage";
import ClientNotificationsPage from "./AdminDashboard/dashscreen/eraser/ClientNotificationsPage";
import ClientDefaultersPage from "./AdminDashboard/dashscreen/eraser/ClientDefaultersPage";
import ClientDefaultersCreatePage from "./AdminDashboard/dashscreen/eraser/ClientDefaultersCreatePage";
import LawyerDashboard from "./AdminDashboard/dashscreen/eraser/LawyerDashboard";
import LawyerAssignedNoticesPage from "./AdminDashboard/dashscreen/eraser/LawyerAssignedNoticesPage";
import LawyerDraftsDisplayPage from "./AdminDashboard/dashscreen/eraser/LawyerDraftsDisplayPage";
import LawyerDraftReviewPage from "./AdminDashboard/dashscreen/eraser/LawyerDraftReviewPage";
import LawyerDraftsEditPage from "./AdminDashboard/dashscreen/eraser/LawyerDraftsEditPage";
import LawyerDocumentRequestsPage from "./AdminDashboard/dashscreen/eraser/LawyerDocumentRequestsPage";
import LawyerDocumentRequestsDisplayPage from "./AdminDashboard/dashscreen/eraser/LawyerDocumentRequestsDisplayPage";
import LawyerSignedUploadsPage from "./AdminDashboard/dashscreen/eraser/LawyerSignedUploadsPage";
import LawyerWalletPage from "./AdminDashboard/dashscreen/eraser/LawyerWalletPage";
import LawyerWithdrawalRequestsPage from "./AdminDashboard/dashscreen/eraser/LawyerWithdrawalRequestsPage";
import LawyerProfilePage from "./AdminDashboard/dashscreen/eraser/LawyerProfilePage";
import AITool from "./AdminDashboard/dashscreen/eraser/AITool";
import BlogList from "./AdminDashboard/dashscreen/eraser/BlogList";
import BlogCreate from "./AdminDashboard/dashscreen/eraser/BlogCreate";
import BlogEdit from "./AdminDashboard/dashscreen/eraser/BlogEdit";
import UserProfile from "./AdminDashboard/dashscreen/sidebar/UserProfile";
import ClientPaymentSuccess from "./AdminDashboard/dashscreen/eraser/ClientPaymentSuccess";
import ClientPaymentFailure from "./AdminDashboard/dashscreen/eraser/ClientPaymentFailure";


// Private Route Wrappers for different user types
const PrivateAdminRoutes = () => {
  const location = useLocation();
  const { userData } = useSelector((store) => store.userReducer);
  const isAuthenticated = !!userData;

  return isAuthenticated ? <Outlet /> : <Navigate to="/admin-login" state={{ from: location }} replace />;
};

const PrivateClientRoutes = () => {
  const location = useLocation();
  const { userData } = useSelector((store) => store.userReducer);
  const isAuthenticated = !!userData;

  return isAuthenticated ? <Outlet /> : <Navigate to="/client-login" state={{ from: location }} replace />;
};

const PrivateLawyerRoutes = () => {
  const location = useLocation();
  const { userData } = useSelector((store) => store.userReducer);
  const isAuthenticated = !!userData;

  return isAuthenticated ? <Outlet /> : <Navigate to="/lawyer-login" state={{ from: location }} replace />;
};

export default function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AdminLogin />} />


          <Route path="/admin-login" element={<AdminLogin />} />

          <Route path="/client-login" element={<ClientLogin />} />
          <Route path="/client-signup" element={<RegisterClient />} />
          <Route path="/client-payment-success" element={<ClientPaymentSuccess />} />
          <Route path="/client-payment-failure" element={<ClientPaymentFailure />} />
          <Route path="/lawyer-login" element={<LawyerLogin />} />
          <Route path="/lawyer-signup" element={<LawyerRegister />} />
          <Route path="/admin-dashboard" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminDashboard />} />
          </Route>
          <Route path="/admin-users" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminUsersPage />} />
          </Route>
          <Route path="/admin-users-create" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminUsersCreatePage />} />
          </Route>
          <Route path="/admin-advocates" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminAdvocatesPage />} />
          </Route>
          <Route path="/admin-advocates-create" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminAdvocatesCreatePage />} />
          </Route>
          <Route path="/admin-notices" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminNoticesPage />} />
          </Route>
          <Route path="/admin-notices-create" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminNoticesCreatePage />} />
          </Route>
          <Route path="/admin-payments" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminPaymentsPage />} />
          </Route>
          <Route path="/admin-payments-create" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminPaymentsCreatePage />} />
          </Route>
          <Route path="/admin-withdrawals" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminWithdrawalsPage />} />
          </Route>
          <Route path="/admin-withdrawals-create" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminWithdrawalsCreatePage />} />
          </Route>
          <Route path="/admin-documents" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminDocumentsPage />} />
          </Route>
          <Route path="/admin-documents-create" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminDocumentsCreatePage />} />
          </Route>
          <Route path="/admin-templates" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminTemplatesPage />} />
          </Route>
          <Route path="/admin-templates-create" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminTemplatesCreatePage />} />
          </Route>
          <Route path="/admin-integrations" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminIntegrationsPage />} />
          </Route>
          <Route path="/admin-integrations-create" element={<PrivateAdminRoutes />}>
            <Route index element={<AdminIntegrationsCreatePage />} />
          </Route>


          
          <Route path="/client-dashboard" element={<PrivateClientRoutes />}>
            <Route index element={<ClientDashboard />} />
          </Route>
          <Route path="/client-notice-submission" element={<PrivateClientRoutes />}>
            <Route index element={<ClientNoticeSubmission />} />
          </Route>
          <Route path="/client-defaulters" element={<PrivateClientRoutes />}>
            <Route index element={<ClientDefaultersPage />} />
          </Route>
          <Route path="/client-defaulters-create" element={<PrivateClientRoutes />}>
            <Route index element={<ClientDefaultersCreatePage />} />
          </Route>
          <Route path="/client-my-notices" element={<PrivateClientRoutes />}>
            <Route index element={<ClientMyNotices />} />
          </Route>
          <Route path="/client-documents" element={<PrivateClientRoutes />}>
            <Route index element={<ClientDocuments />} />
          </Route>
          <Route path="/client-payments" element={<PrivateClientRoutes />}>
            <Route index element={<ClientPayments />} />
          </Route>
          <Route path="/client-delivery-tracking" element={<PrivateClientRoutes />}>
            <Route index element={<ClientDeliveryTracking />} />
          </Route>
          <Route path="/client-downloads" element={<PrivateClientRoutes />}>
            <Route index element={<ClientDownloads />} />
          </Route>
          <Route path="/client-profile" element={<PrivateClientRoutes />}>
            <Route index element={<ClientProfilePage />} />
          </Route>
          <Route path="/client-notifications" element={<PrivateClientRoutes />}>
            <Route index element={<ClientNotificationsPage />} />
          </Route>
          <Route path="/lawyer-dashboard" element={<PrivateLawyerRoutes />}>
            <Route index element={<LawyerDashboard />} />
          </Route>
          <Route path="/lawyer-assigned-notices" element={<PrivateLawyerRoutes />}>
            <Route index element={<LawyerAssignedNoticesPage />} />
          </Route>
          <Route path="/lawyer-drafts-display" element={<PrivateLawyerRoutes />}>
            <Route index element={<LawyerDraftsDisplayPage />} />
          </Route>
          <Route path="/lawyer-draft-review" element={<PrivateLawyerRoutes />}>
            <Route index element={<LawyerDraftReviewPage />} />
          </Route>
          <Route path="/lawyer-drafts-edit" element={<PrivateLawyerRoutes />}>
            <Route index element={<LawyerDraftsEditPage />} />
          </Route>
          <Route path="/lawyer-document-requests" element={<PrivateLawyerRoutes />}>
            <Route index element={<LawyerDocumentRequestsPage />} />
          </Route>
          <Route path="/lawyer-document-requests-display" element={<PrivateLawyerRoutes />}>
            <Route index element={<LawyerDocumentRequestsDisplayPage />} />
          </Route>
          <Route path="/lawyer-signed-uploads" element={<PrivateLawyerRoutes />}>
            <Route index element={<LawyerSignedUploadsPage />} />
          </Route>
          <Route path="/lawyer-wallet" element={<PrivateLawyerRoutes />}>
            <Route index element={<LawyerWalletPage />} />
          </Route>
          <Route path="/lawyer-withdrawal-requests" element={<PrivateLawyerRoutes />}>
            <Route index element={<LawyerWithdrawalRequestsPage />} />
          </Route>
          <Route path="/lawyer-profile" element={<PrivateLawyerRoutes />}>
            <Route index element={<LawyerProfilePage />} />
          </Route>

          {/* Legacy aliases */}
          <Route path="/login" element={<Navigate to="/client-login" replace />} />
          <Route path="/signup" element={<Navigate to="/client-signup" replace />} />


          {/* Private Routes */}
          <Route path="/admin" element={<PrivateAdminRoutes />}>
            <Route element={<SideBarScreen />}>
              <Route index element={<DashBoardScreen />} />
              <Route path="admin-dashboard" element={<AdminDashboard />} />
              <Route path="home-directory-manager" element={<HomeDirectoryManager />} />
              <Route path="ai-tool" element={<AITool />} />
              <Route path="blogs" element={<BlogList />} />
              <Route path="blogs/create" element={<BlogCreate />} />
              <Route path="blogs/edit/:id" element={<BlogEdit />} />
              
            </Route>
          </Route>


          <Route path="/user" element={<PrivateClientRoutes />}>
            <Route element={<ClientSideBarScreen />}>
              <Route index element={<ClientDashboard />} />
              <Route path="user-dashboard" element={<ClientDashboard />} />
              <Route path="profile" element={<UserProfile />} />

            </Route>
          </Route>


        </Routes>
      </BrowserRouter>
    </Provider>
  );
}
